import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class CityService extends Service{
    constructor() {
        super();
        this.baseURL = 'task';
    }

    findByRequestTypeAndRequestId(requestType, requestId) {
        return fetch(SERVER_URL + this.baseURL + '/findByRequestTypeAndRequestId/' + requestType + '/' + requestId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    haveAnyRecord(requestType, requestId) {
        return fetch(SERVER_URL + this.baseURL + '/haveAnyRecord/' + requestType + '/' + requestId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}